<!-- 用户功能 - 重置密码确认 -->

<template>
  <div>
    <div class="Reset-content">
      <div class="Reset-content-title">
        <ul class="clearfix">
          <li class="active">安全验证</li>
          <li class="active">重置密码</li>
          <li>修改成功</li>
        </ul>
        <div class="line">
          <span class="One"></span>
          <span class="Two"></span>
          <span class="Three"></span>
        </div>
      </div>
      <div class="Reset-content-tab">
        <!-- Phone Start -->
        <div class="form">
          <div class="form-phone">
            <input
              type="password"
              class="phone"
              placeholder="新密码"
              v-model="passWord"
            />
          </div>
          <div class="form-code">
            <input
              type="password"
              class="phone"
              placeholder="确认密码"
              v-model="CpassWord"
            />
          </div>
          <div class="form-btn">
            <input type="button" value="重置密码" @click="submit" />
          </div>
        </div>
        <!-- Phone Start -->
      </div>
    </div>
  </div>
</template>
<script>
import Regx from "../../lib/const";
// 模态框UI组件
import MsgModal from "../common/MsgModal";
export default {
  data() {
    return {
      passWord: "",
      CpassWord: "",
      Reg: {
        phone: /^1[34578]\d{9}$/,
        email:
          /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
        Modal: false,
        text: "",
      },
      query: {},
      //公钥
      pubKey: "",
    };
  },
  mounted() {
    this.query = this.$queryUrlParams();
    this.getEncryptPubKey();
  },
  methods: {
    //获取公钥
    getEncryptPubKey() {
      this.$axios
        .request({
          url: "/webapi/user/getEncryptPubKey",
          method: "GET",
          params: {},
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.pubKey = res.data.datas.encryptPubKey;
          }
        });
    },
    /**
     * 通过公钥进行加密
     * data:要加密的数据
     */
    setEncrypt(data) {
      const jsRsa = new this.$jsEncrypt();
      //设置公钥
      jsRsa.setPublicKey(this.pubKey);
      //使用加密对象给数据加密
      let RsaData = jsRsa.encrypt(data);
      return RsaData;
    },
    submit() {
      if (this.CpassWord != this.passWord) {
        this.$store.dispatch("showMsgModal", {
          autoClose: true,
          info: "两次输入的密码不一致",
        });
        return;
      } else if (!Regx.INPUTRULES.password.test(this.passWord)) {
        this.$store.dispatch("showMsgModal", {
          autoClose: true,
          info: "密码格式有误",
        });
        return;
      } else {
        if (typeof this.query.account != "undefined") {
          this.$axios
            .post("/webapi/user/resetPwdV2", {
              encryptAccount: this.setEncrypt(this.query.account),
              encryptPassword: this.setEncrypt(this.$md5(this.passWord)),
            })
            .then((res) => {
              if (res.data.code == "200") {
                this.$router.push({
                  path: "/reset/resetresult",
                  query: { status: res.data.code },
                });
              } else {
                this.$store.dispatch("showMsgModal", {
                  autoClose: false,
                  info: res.data.message,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    closeModal() {
      this.Reg.Modal = false;
    },
  },
};
</script>
<style scoped>
.exit {
  opacity: 0 !important;
  pointer-events: none !important;
}
.start {
  opacity: 1 !important;
  pointer-events: auto !important;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *+height: 1%;
}
/*Content Start*/
.Reset-content {
  width: 640px;
  height: 400px;
  margin: 70px auto 0 auto;
}
.Reset-content > .Reset-content-title {
  height: 60px;
}
.Reset-content-title > ul > li {
  width: 33.3%;
  float: left;
  text-align: center;
}
.Reset-content-title > ul > .active {
  color: #b71d2a;
}
.line {
  width: 430px;
  height: 15px;
  border-bottom: solid 1px #d0d0d0;
  position: relative;
  margin-top: 5px;
  margin: 0 auto;
}
.line > span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: absolute;
  bottom: -7px;
}
.line > span:nth-child(1) {
  left: 0px;
  background-color: #b71d2a;
}
.line > span:nth-child(2) {
  left: 50%;
  background-color: #b71d2a;
  transform: translate(-50%, 0);
}
.line > span:nth-child(3) {
  right: 0px;
  background-color: #ccc;
}
.Reset-content > .Reset-content-tab {
  width: 370px;
  margin: 0 auto;
}
.form {
}
.form-phone {
  margin-top: 40px;
}
.form-phone > input,
.form-code > input {
  width: 363px;
}
.phone {
  height: 42px;
  border: solid 1px #909090;
  border-radius: 3px;
  line-height: 42px;
  padding-left: 14px;
  box-sizing: border-box;
}
.form-code {
  margin-top: 30px;
}
.form-btn {
  margin-top: 33px;
}
.form-btn > input {
  background-color: #b71d2a;
  width: 100%;
  border: solid 1px #fff;
  height: 44px;
  color: #fff;
  cursor: pointer;
}
/*End*/
</style>



// WEBPACK FOOTER //
// Confirm.vue?fa6eeb24